import React from "react";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import ProduitDetailContent from "./ProduitDetailContent";

const ProduitItemPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === "number" && idx > 0) {
      navigate(-1);
      return;
    }
    navigate("/produits");
  };

  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content bg-white pb-5">
        <div className="container-easy-market">
          <div
            className="content-back-to pt-3 pb-3"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e?.preventDefault();
              handleBack();
            }}
            onKeyDown={(e) => e.key === "Enter" && handleBack()}
          >
            <HiOutlineArrowLeft style={{ fontSize: 18 }} />
            <span className="ps-2 go-back-btn">RETOUR</span>
          </div>

          <ProduitDetailContent />
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default ProduitItemPage;